import React from "react";

// Five-dot rating, as on the CV. Dots pop in when their Reveal ancestor scrolls into view.
const Meter = ({ level, max = 5, label }) => (
    <span role="img" aria-label={`${label}: ${level} out of ${max}`} className="flex shrink-0 gap-1.5">
        {Array.from({ length: max }, (_, i) => (
            <span
                key={i}
                className={`meter-dot h-2 w-2 rounded-full ${i < level ? "bg-accent" : "bg-fg/15"}`}
                style={{ "--i": i }}
            />
        ))}
    </span>
);

export default Meter;
